// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/mobile.handsontable.css
// module id = 228
// module chunks = 0